(() => {
  const section = document.querySelector('.customer-reviews');
  if (!section) return;
  const track = section.querySelector('.review-track');
  const slides = [...track.children];
  const prev = section.querySelector('.reviews-prev');
  const next = section.querySelector('.reviews-next');
  const status = section.querySelector('.review-position');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const offset = slide => slide.offsetLeft - slides[0].offsetLeft;
  const stops = () => [...new Set(slides.map(slide => Math.min(offset(slide), track.scrollWidth - track.clientWidth)))];
  function update() {
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    const visible = slides.map((slide,i) => ({i,left:offset(slide)-track.scrollLeft,width:slide.clientWidth})).filter(s => s.left+s.width>2 && s.left<track.clientWidth-2);
    if (visible.length) status.textContent = `${visible[0].i+1}–${visible.at(-1).i+1} / ${slides.length}`;
  }
  function move(direction) {
    const positions=stops();
    const target=direction>0 ? positions.find(x=>x>track.scrollLeft+2) ?? positions.at(-1) : positions.filter(x=>x<track.scrollLeft-2).at(-1) ?? 0;
    track.scrollTo({left:target,behavior:reduced.matches?'instant':'smooth'});
  }
  prev.addEventListener('click',()=>move(-1));
  next.addEventListener('click',()=>move(1));
  track.addEventListener('keydown',event=>{
    if(event.target!==track)return;
    if(['ArrowRight','ArrowLeft'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}
  });
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(track);
  const videos=[...track.querySelectorAll('video')];
  const visibleVideos=new Set();
  const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting,intersectionRatio})=>{
    if(isIntersecting && intersectionRatio>=.5){visibleVideos.add(target);if(!reduced.matches && !document.hidden)target.play().catch(()=>{});}
    else {visibleVideos.delete(target);target.pause();}
  }),{threshold:[0,.5]});
  videos.forEach(video=>{
    observer.observe(video);
    video.addEventListener('volumechange',()=>{if(!video.muted)videos.forEach(other=>{if(other!==video)other.muted=true;});});
  });
  document.addEventListener('visibilitychange',()=>videos.forEach(video=>{
    if(document.hidden)video.pause();else if(visibleVideos.has(video)&&!reduced.matches)video.play().catch(()=>{});
  }));
  reduced.addEventListener('change',()=>{if(reduced.matches)videos.forEach(video=>video.pause());});
  update();
})();
